var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnlineOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8EAEBA"
    },
    d: "M376,472c0,13.6-10.4,24-24,24H144c-13.6,0-24-10.4-24-24V32c0-13.6,10.4-24,24-24h208 c13.6,0,24,10.4,24,24V472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M376,464c0,13.6-10.4,24-24,24H144c-13.6,0-24-10.4-24-24V24c0-13.6,10.4-24,24-24h208 c13.6,0,24,10.4,24,24V464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7EAF7"
    },
    d: "M376,464c0,13.6-10.4,24-24,24H144c-13.6,0-24-10.4-24-24V32c0-13.6,10.4-24,24-24h208 c13.6,0,24,10.4,24,24V464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1D8E5"
    },
    d: "M144,8h208c13.6,0,24,8,24,20.8v437.6c0,13.6-10.4,21.6-24,21.6H144"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A7C4D1"
    },
    d: "M352,8c13.6,0,24,8,24,20.8v437.6c0,13.6-10.4,21.6-24,21.6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 56,
    style: {
      fill: "#094670"
    },
    width: 256,
    height: 384
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#00233F"
    },
    points: "376,440 376,56 120,56 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 56,
    style: {
      fill: "#EA7711"
    },
    width: 224,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 72,
    style: {
      fill: "#FFA515"
    },
    width: 224,
    height: 368
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#ED900A"
    },
    points: "360,440 360,72 136,72 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 207.2,
    cy: 22.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 219.2,
    cy: 22.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 230.4,
    cy: 22.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 242.4,
    cy: 22.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 253.6,
    cy: 22.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 265.6,
    cy: 22.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 276.8,
    cy: 22.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 288.8,
    cy: 22.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 207.2,
    cy: 32.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 219.2,
    cy: 32.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 230.4,
    cy: 32.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 242.4,
    cy: 32.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 253.6,
    cy: 32.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 265.6,
    cy: 32.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 276.8,
    cy: 32.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 288.8,
    cy: 32.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 207.2,
    cy: 43.2,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 219.2,
    cy: 43.2,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 230.4,
    cy: 43.2,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 242.4,
    cy: 43.2,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 253.6,
    cy: 43.2,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 265.6,
    cy: 43.2,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 276.8,
    cy: 43.2,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 288.8,
    cy: 43.2,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 207.2,
    cy: 452.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 219.2,
    cy: 452.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 230.4,
    cy: 452.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 242.4,
    cy: 452.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 253.6,
    cy: 452.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 265.6,
    cy: 452.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 276.8,
    cy: 452.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 288.8,
    cy: 452.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 207.2,
    cy: 462.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 219.2,
    cy: 462.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 230.4,
    cy: 462.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 242.4,
    cy: 462.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 253.6,
    cy: 462.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 265.6,
    cy: 462.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 276.8,
    cy: 462.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 288.8,
    cy: 462.4,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 207.2,
    cy: 472.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 219.2,
    cy: 472.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 230.4,
    cy: 472.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 242.4,
    cy: 472.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 253.6,
    cy: 472.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 265.6,
    cy: 472.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 276.8,
    cy: 472.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#95AAB5"
    },
    cx: 288.8,
    cy: 472.8,
    r: 3.2
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93B5C1"
    },
    d: "M345.6,28.8c0,6.4-4.8,14.4-11.2,14.4c-6.4,0-11.2-8.8-11.2-14.4s4.8-11.2,11.2-11.2 C340.8,17.6,345.6,22.4,345.6,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFF1F7"
    },
    d: "M323.2,28.8c0-6.4,4.8-13.6,11.2-13.6c6.4,0,11.2,7.2,11.2,13.6"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00233F"
    },
    cx: 334.4,
    cy: 28.8,
    r: 11.2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2E79A3"
    },
    cx: 334.4,
    cy: 28.8,
    r: 7.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#225A7F"
    },
    d: "M329.6,24c3.2-3.2,8-3.2,10.4,0c3.2,3.2,3.2,8,0,10.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#53ACD3"
    },
    cx: 330.4,
    cy: 28,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#53ACD3"
    },
    cx: 336.8,
    cy: 32.8,
    r: 1.6
  })), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 408,
    style: {
      fill: "#ED900A"
    },
    width: 224,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#094670"
    },
    d: "M184,32c0,4.8-3.2,8-6.4,8h-26.4c-4,0-7.2-3.2-7.2-8l0,0c0-4.8,3.2-8,6.4-8h26.4 C180.8,24,184,27.2,184,32L184,32z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#27D68A"
    },
    cx: 152,
    cy: 29.6,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15AF83"
    },
    d: "M152,25.6c2.4,0,4,1.6,4,4s-1.6,4-4,4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFFFEF"
    },
    d: "M150.4,28c0,0.8-0.8,0.8-1.6,0.8S148,28,148,27.2s0.8-0.8,0.8-0.8C150.4,27.2,150.4,28,150.4,28z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineOrder);
export default __webpack_public_path__ + "static/media/online-order.b9cc64e41fc1432da82f932071ddeac1.svg";
export { ForwardRef as ReactComponent };